import React, { useEffect, useState } from "react";
import GlobalWrapper from "../../components/Wrapper/GlobalWrapper";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import FromAndToDatePicker from "../../components/mui/FromAndToDatePicker";
import dayjs from "dayjs";
import GlobalMultiSelectNew from "../../components/mui/GlobalMultiSelectNew";
import GlobalDatagrid from "../../components/mui/DataGrid/GlobalDatagrid";
import { useLocation, useNavigate } from "react-router-dom";
import { getCRMlist, getDetailwiseData } from "../../redux/features/srtSlice";
import { SRT_CRO_VIEW } from "../../components/datagrid/srt/SrtCrotablehead";

const Srtcroview = () => {
  const userProfile = JSON.parse(localStorage.getItem("cred")).profile;

  const userId = userProfile.userId;

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const fromdate = searchParams.get("fromDate");
  const todate = searchParams.get("toDate");
  const projectId = searchParams.get("projectId");

  const [fromDate, setFromDate] = useState(
    fromdate || dayjs().startOf("month").format("YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(
    todate || dayjs().endOf("month").format("YYYY-MM-DD")
  );

  const [selectedCRM, setselectedValue] = useState([]);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { srtdetaildata, crmlist, loading } = useSelector((state) => state.srt);
  const { paginationData } = useSelector((state) => state.globalDataGrid);
  const { gridSize, pageNum, rowData, openAnchor, search } = paginationData;

  useEffect(() => {
    if (pageNum) {
      dispatch(
        getDetailwiseData({
          page: pageNum,
          limit: gridSize,
          projectId: projectId,
          userId: userId,
          crmId: selectedCRM,
          fromDate: fromDate,
          toDate: toDate,
        })
      );
    }
  }, [
    selectedCRM,
    fromDate,
    toDate,
    projectId,
    userId,
    pageNum,
    gridSize,
    dispatch,
  ]);

  useEffect(() => {
    dispatch(
      getCRMlist({
        projectId: projectId,
      })
    );
  }, []);

  const handlecrm = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue === "") {
      setselectedValue([]);
    } else {
      setselectedValue(selectedValue);
    }
  };

  return (
    <GlobalWrapper title={"Reschedule Report"}>
      <Box sx={{ display: "flex", mb: 1, gap: "10px", flexDirection: "row" }}>
        <FromAndToDatePicker
          disabled={false}
          fromDate={fromDate}
          toDate={toDate}
          setFromDate={setFromDate}
          setToDate={setToDate}
        />
        {/* <GlobalMultiSelectNew
          disabled={loading}
          label={"CRM"}
          arrayState={selectedCRM}
          arraySetState={setSelectedCRM}
          data={crmlist}
          keys={{ id: "name", value: "userID" }}
        /> */}
        {/* <GlobalMultiSelectNew
          disabled={loading}
          label={"CRO"}
          arrayState={selectedCRO}
          arraySetState={setSelectedCRO}
          data={crodemo}
          keys={{ id: "name", value: "name" }}
        /> */}
        <Box
          sx={{
            width: 300,
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="crm">CRM</InputLabel>
            <Select
              labelId="crm-filter"
              id="crm-filter"
              value={selectedCRM}
              autoWidth
              label="CRM"
              onChange={handlecrm}
            >
              <MenuItem value="">ALL</MenuItem>
              {crmlist.map((crm) => (
                <MenuItem key={crm.userID} value={crm.userID}>
                  {crm.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      </Box>

      <Box sx={{ width: "100%", padding: 0 }}>
        <GlobalDatagrid
          tableHead={SRT_CRO_VIEW(navigate, fromDate, toDate, projectId)}
          rows={srtdetaildata.data}
          meta={srtdetaildata?.meta?.totalRecords || 0}
          rowUniqueId="croId"
          loading={loading}
          rowClick={false}
        />
      </Box>
    </GlobalWrapper>
  );
};

export default Srtcroview;
